import { render, staticRenderFns } from "./ZiXunList.vue?vue&type=template&id=ca4603e2&scoped=true&"
import script from "./ZiXunList.vue?vue&type=script&lang=js&"
export * from "./ZiXunList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4603e2",
  null
  
)

export default component.exports